import React from 'react';
import ReactDom from 'react-dom';

class Inject extends React.Component {

  componentDidMount() {
    this.node = document.createElement('div');
    const element = this.getElement();

    element.appendChild(this.node);
    this.renderManually(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.renderManually(nextProps);
  }

  componentWillUnmount() {
    ReactDom.unmountComponentAtNode(this.node);
    this.getElement().removeChild(this.node);
  }

  getElement() {
    let element;

    if (this.props.id) {
      element = document.getElementById(this.props.id);
    } else if (this.props.className) {
      element = document.getElementsByClassName(this.props.className)[0];
    }

    return element || document.body;
  }

  renderManually(props) {
    ReactDom.unstable_renderSubtreeIntoContainer(this, props.children, this.node);
  }

  render() {
    return React.DOM.noscript();
  }
}

export default Inject;



// WEBPACK FOOTER //
// ./src/app/components/Inject.js